var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0814 6.70001L12.3 1.91868C11.4109 1.07018 10.2291 0.596771 9.00003 0.596771C7.77099 0.596771 6.58917 1.07018 5.70003 1.91868L0.918694 6.70001C0.543677 7.0752 0.333066 7.58401 0.333191 8.11448C0.333316 8.64496 0.544167 9.15366 0.91936 9.52868C1.29455 9.90369 1.80335 10.1143 2.33383 10.1142C2.86431 10.1141 3.37301 9.9032 3.74803 9.52801L7.00003 6.27601V19.3333C7.00003 19.8638 7.21074 20.3725 7.58581 20.7476C7.96089 21.1226 8.46959 21.3333 9.00003 21.3333C9.53046 21.3333 10.0392 21.1226 10.4142 20.7476C10.7893 20.3725 11 19.8638 11 19.3333V6.27601L14.252 9.52801C14.4377 9.71379 14.6582 9.86117 14.9008 9.96175C15.1435 10.0623 15.4036 10.1141 15.6662 10.1142C15.9289 10.1142 16.189 10.0626 16.4317 9.96211C16.6744 9.86165 16.8949 9.71437 17.0807 9.52868C17.2665 9.34299 17.4139 9.12253 17.5144 8.87988C17.615 8.63723 17.6668 8.37715 17.6669 8.11448C17.6669 7.85182 17.6153 7.59171 17.5148 7.34902C17.4143 7.10632 17.2671 6.88579 17.0814 6.70001Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.906d1d0f421328808a9592deb3d5c7e8.svg";
export { ForwardRef as ReactComponent };